import { useDispatch } from "react-redux";
import {
  setAuthToken,
  setOriginalRoleAction,
  setRoleAction,
  setUser,
} from "redux/features/authSlice/AuthSlice";
import {
  setHostDetails,
  setTrialDetails,
} from "redux/features/hostSlice/addTrialSlice/addTrialSlice";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";

export const useLogout = () => {
  const dispatch = useDispatch();

  const onLogout = () => {
    dispatch(setUser(null));
    dispatch(setAuthToken(""));
    dispatch(setMemberDetails(null));
    dispatch(setHostDetails(null));
    dispatch(setTrialDetails(null));
    dispatch(setRoleAction(""));
    dispatch(setOriginalRoleAction(""));
  };

  return { onLogout };
};
